<template>
  <div class="pc-menu" @click="changeNav">
    <template v-for="(menu, index) in menuListMap">
    <a
      class="menu-item menu-item-px"
      :data-index="index + 1"
      href="javascript:;"
      v-if="menu.name === 'topUp' ? isStore : true"
      :key="index"
      >{{ $t(menu.name) }}
      <div v-if="menu.name === 'topUp'" class="hot"></div>
    </a>
    </template>
  </div>
</template>

<script lang="ts" setup>
import menuHook from '@/hooks/menuHook';
const { changeNav, menuListMap, isStore } = menuHook();
</script>
